import ellipsis from '../ellipsis';
import jsonRedact from '../jsonRedact';

/**
 * Create a parsed string response from Axios error message(s)
 * @param {Axios.Response} [o.response]
 * @returns {string?}
 */
export default function axiosErrorResponse({ response } = {}) {
    if (!response) { return; }

    const { status, data } = response;

    return [
        status,
        ellipsis(
            JSON.stringify(
                data,
                jsonRedact
            ),
            100
        )
    ].join(': ');
}
